import type { ParseKeys } from 'i18next';
import { Tab } from '../process-analysis.type';

interface TabEntry {
  id: Tab;
  textKey: ParseKeys<'translation'>;
  icon: string;
}

const tabs: TabEntry[] = [
  { id: Tab.Portfolios, textKey: 'common.portfolios', icon: 'cases' },
  { id: Tab.Teams, textKey: 'common.projects', icon: 'inventory_2' },
  { id: Tab.Boards, textKey: 'common.boards', icon: 'space_dashboard' },
];

export { tabs, type TabEntry };
